/*
Las URL de Servicio y FrontEnd no deben contener
slash (/) al final de la URL.
*/

//Entorno Producción
export const OBTENER_URL_SERVICIO = "https://serviciosweb.konradlorenz.edu.co/Digiturno-backend";
export const OBTENER_URL_FRONTEND = "https://serviciosweb.konradlorenz.edu.co/digiturno";
export const ID_CLIENTE_MICROSOFT = "d0852b94-1ef4-453d-881d-5c50257ecd6e";

//Entorno Desarrollo local
//export const OBTENER_URL_SERVICIO = "http://localhost:8080/Digiturno";
//export const OBTENER_URL_FRONTEND = "http://localhost:3000";
//export const ID_CLIENTE_MICROSOFT = "3d255cc1-8d3b-4568-8301-e974bd87d912";

export const VALIDAR_USUARIO = "VALIDAR_USUARIO";
export const SELECCIONAR_ROL = "SELECCIONAR_ROL";
export const TRAER_SERVICIOS = "TRAER_SERVICIOS";
export const VALIDAR_AGENTE = "VALIDAR_AGENTE";
export const SESION_AGENTE = "SESION_AGENTE";
export const ACTUALIZAR_LISTA = "ACTUALIZAR_LISTA";
export const AGENTE_LOGOUT = "AGENTE_LOGOUT";
export const VALIDAR_AREA = "VALIDAR_AREA";
export const SESION_AREA = "SESION_AREA";
export const OBTENER_AREAS = "OBTENER_AREAS";
export const OBTENER_COLA = "OBTENER_COLA";